module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-compare-reserve__percentage"
  }, [_c('div', {
    staticClass: "p-compare-reserve__slider"
  }, [_c('vue-slider', {
    ref: "slider",
    attrs: {
      "min": -1,
      "max": 1,
      "interval": 0.1,
      "real-time": true,
      "clickable": true,
      "bg-style": _vm.backgroundStyle,
      "process-style": {
        'backgroundColor': '#a6a6a6'
      },
      "tooltip-style": [{
          'backgroundColor': '#85f7d9',
          'borderColor': '#85f7d9',
          'color': 'black',
          'padding': '8px 12px 5px',
        },
        {
          'backgroundColor': '#e68bb4',
          'borderColor': '#e68bb4',
          'color': 'black',
          'padding': '8px 12px 5px',
        }
      ],
      "label-style": {
        'color': '#fff'
      },
      "formatter": _vm.rangeDisplay
    },
    model: {
      value: (_vm.range),
      callback: function($$v) {
        _vm.range = $$v
      },
      expression: "range"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "u-text-center"
  }, [_vm._v("\n        Set your percentage over/under range.\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-604f76ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/compare/components/Slider.vue
// module id = 1716
// module chunks = 0